
export function Intro() {
    return (
        <div style={{ height: "90vh", width: "100%", display: "flex", flexDirection: "column" }}>
            <div dangerouslySetInnerHTML={{ __html: "<iframe src='https://cdn.knightlab.com/libs/timeline3/latest/embed/index.html?source=1n-8-FkqEqL-hZbaXNfr5ApCmQKAhRsdSjKSMdV5JNKQ&font=Default&lang=en&timenav_position=top&initial_zoom=1&height=650' width='100%' height='650' webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder='0'></iframe>"}} />
        </div>
    )
}
